/**
 * Cloudflare Turnstile configuration, in one place.
 *
 * These two constants were copied verbatim into AuthModal and RegisterPage,
 * and the anonymous intake start (spec b5b59843, control C-6) needed a third
 * copy — which is the point at which a copy becomes a liability rather than a
 * convenience. The API's rule is global, so the client's reading of it should
 * be too: a widget that is enabled on one surface and not another is a 400 the
 * visitor cannot act on.
 */
export const TURNSTILE_SITE_KEY =
  typeof import.meta.env.VITE_TURNSTILE_SITE_KEY === "string"
    ? import.meta.env.VITE_TURNSTILE_SITE_KEY.trim()
    : "";

/**
 * PRODUCTION BUNDLE ONLY, and that mirrors the API rather than being a
 * convenience for us: `assertTurnstileIfConfigured` (auth.service.ts) returns
 * early unless `NODE_ENV === 'production'` AND `TURNSTILE_SECRET_KEY` is set,
 * so a widget rendered in `vite dev` would be asking the visitor to solve a
 * challenge nothing is going to check.
 *
 * The inverse is the failure this flag exists to prevent, and it has happened
 * twice: a deployed build WITHOUT the site key sends no token to an API that
 * requires one, and the visitor sees a generic error for a captcha they were
 * never shown. So on any deployed environment where the API carries
 * TURNSTILE_SECRET_KEY, VITE_TURNSTILE_SITE_KEY must be set at BUILD time —
 * it is inlined by Vite, so setting it afterwards changes nothing until the
 * next build.
 */
export const turnstileEnabled = import.meta.env.PROD && TURNSTILE_SITE_KEY.length > 0;
